import styled from "styled-components";

export const TitleWithBorder = styled.span`
  font-family: "ST-SimpleSquare", sans-serif;
  border-bottom: 1px solid var(--grey-primary);
  display: block;
  font-weight: 400;
  padding-left: 8px;
  padding-bottom: 16px;
`;
